import useHistory from "@/hooks/use-history";

import MobileBackButton, {
  type MobileBackButtonProps,
} from "./mobile-back-button";
import MobileExploreButton, {
  type MobileExploreButtonProps,
} from "./mobile-explore-button";

interface BackOrExploreButtonProps extends React.ComponentProps<"button"> {
  backButtonProps?: MobileBackButtonProps;
  canGoBack?: boolean;
  exploreButtonProps?: MobileExploreButtonProps;
}

export default function BackOrExploreButton({
  backButtonProps,
  canGoBack: forceGoBack,
  exploreButtonProps,
  ...props
}: BackOrExploreButtonProps) {
  const { canGoBack } = useHistory();
  const shouldGoBack = forceGoBack ?? canGoBack;

  return shouldGoBack ? (
    <MobileBackButton {...props} {...backButtonProps} />
  ) : (
    <MobileExploreButton {...props} {...exploreButtonProps} />
  );
}
